import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AbstractEntity } from "../Models/abstract-entity";
import { Response } from "../Models/response";
import { Page } from "../Models/page";

// export class Pageable<E extends AbstractEntity<any>> {
//   totalPages: number;
//   content: E[];
// }

export abstract class AbstractService<E extends AbstractEntity<ID>, ID> {
  // TODO piping observables in separate function so we can have consistent behavior
  // TODO have errors be our custom error E so we can handel errors our way

  protected constructor(protected http: HttpClient) {}

  public abstract get url(): string;

  public getAll(): Observable<E[]> {
    return this.http.get<E[]>(this.url).pipe(
      map((response: E[]) => {
        if (response) {
          return response;
        } else {
          throw new Error();
        }
      })
    );
  }

  public getAllPaged(page = 0, size = 1): Observable<Page<E>> {
    const options = {
      params: new HttpParams()
        .set("page", page.toString())
        .set("size", size.toString()),
    };
    const urlGetPaged = `${this.url}/pages`;
    return this.http.get<Page<E>>(urlGetPaged, options).pipe(
      map((response: Page<E>) => {
        if (response) {
          return response;
        } else {
          throw new Error();
        }
      })
    );
  }

  public getById(id: ID): Observable<E> {
    const urlGetById = `${this.url}/${id}`;
    return this.http.get<E>(urlGetById, { withCredentials: true }).pipe(
      map((response: E) => {
        if (response) {
          return response;
        } else {
          throw new Error();
        }
      })
    );
  }

  public add(entity: E): Observable<E> {
    return this.http.post<E>(this.url, entity, {
      withCredentials: true,
    });
  }

  public update(entity: E): Observable<E> {
    return this.http.put<E>(this.url, entity, {
      withCredentials: true,
    });
  }

  public delete(id: ID): Observable<E> {
    const urlDeleteById = this.url.concat("/").concat(String(id));
    return this.http.delete<E>(urlDeleteById, {
      withCredentials: true,
    });
  }
}
